"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Service = void 0;
var Service = /** @class */ (function () {
    function Service() {
    }
    return Service;
}());
exports.Service = Service;
//# sourceMappingURL=Service.js.map